import { axiosNT, axiosNTL } from '../../../services/axios';
import { UserBody } from '../types/UsersBody';


const list = () => {
	return axiosNT.get('/user/usersLastActivity')
		.then((res: any) => {
			let users: UserBody[] = res.responseObject;
			return Promise.resolve(users);
		});
}

export const userServices = {
	list,
}